import { safeInt, getIdEstadoFromNombre } from '../../utilities';

export const setIdEstado = (data) => {
    // idEstado 0 o ausente rompe el alta en Core (FK / validación EF). Alinear con el texto "estado" del formulario (Moderador).
    let idEstado = safeInt(data.idEstado, 0);
    if (data.estado && typeof data.estado === 'string') {
        const mapped = getIdEstadoFromNombre(data.estado);
        if (mapped != null && mapped > 0) {
            idEstado = mapped;
        }
    }
    if (!idEstado || idEstado < 1) {
        idEstado = 1;
    }

    return idEstado;
}